import { MockNote } from '@/components/foundations';
import { AppShell, PageHeader, PageTitle } from '@/components/layout';
import { Badge, DataTable, InstallmentBadge, Panel, SummaryList } from '@/components/data';
import { BillCard } from './components';
import { BILLS, FIN_TX, brl } from '@/mocks/financas';
import { CATEGORY_ITEMS } from './parts';
import { CategoryBars } from '@/components/charts';

/** Faturas do cartão Inter — mock. */
export function FinFaturasPage() {
  const cardTx = FIN_TX.filter((t) => t.account.startsWith('Cartão'));
  return (
    <AppShell>
      <main className="content">
        <PageHeader subtitle={`Cartão Inter •••• 0597 · limite disponível ${brl(8512.88)}`} period="Novembro 2026" />
        <PageTitle title="Faturas do cartão" />
        <section className="fin-grid-3">
          {BILLS.map((b) => (
            <BillCard key={b.month} status={b.status} month={b.month} amount={b.total} meta={b.note} />
          ))}
        </section>
        <section className="dash-grid">
          <Panel variant="recent" head="bar" title="Lançamentos · novembro">
            <DataTable
              rows={cardTx}
              rowKey={(t) => t.id}
              columns={[
                { key: 'date', header: 'Data', render: (t) => t.date },
                { key: 'desc', header: 'Descrição', cellClassName: 'wrap', render: (t) => <>{t.desc} {t.installment && <InstallmentBadge value={t.installment} />}</> },
                { key: 'cat', header: 'Categoria', hideOnMobile: true, render: (t) => <Badge tone="neutral">{t.category}</Badge> },
                { key: 'val', header: 'Valor', align: 'right', render: (t) => brl(-t.amount) },
              ]}
            />
          </Panel>
          <Panel title="Composição">
            <SummaryList
              items={[
                { label: 'Compras novas', value: brl(2452.42) },
                { label: 'Parcelas', value: brl(1034.7) },
              ]}
              total={{ label: 'Total da fatura', value: brl(3487.12), valueStyle: { color: 'var(--navy)' } }}
            />
            <h2 style={{ margin: '22px 0 6px' }}>Por categoria</h2>
            <CategoryBars items={CATEGORY_ITEMS} max={1800} format={brl} />
          </Panel>
        </section>
        <MockNote />
      </main>
    </AppShell>
  );
}
